export default "__VITE_ASSET__BPoJB32Y__"